import React from 'react';
import { m } from 'framer-motion';
import { Helmet } from 'react-helmet-async';
import Footer from '../Footer/Footer';
import useFaq from '../../hooks/useFaq';
import RichTextContent from 'components/RichTextContent/RichTextContent';

export default function Faq() {
  const { faq, isLoading } = useFaq();

  if (isLoading) {
    return null;
  }

  return (
    <m.main
      initial={{ opacity: 0 }}
      animate={{ opacity: 1 }}
      exit={{ opacity: 0 }}
      transition={{ duration: 0.5 }}
      className="faq"
    >
      <Helmet>
        <title>Frequently Asked Questions - DuskBreakers</title>
        <meta
          name="description"
          content="Explore the most frequently asked questions about the DuskBreakers project."
        />
      </Helmet>

      <section>
        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-10">
              <h1 className="mb-5">FAQs</h1>
            </div>
          </div>
        </div>

        <div className="container">
          <div className="row d-flex justify-content-center">
            <div className="col-md-10">
              <div className="accordion accordion-dark" id="faq">
                {faq.map(({ order, isTitle, isBlurb, question, answer }) => {
                  if (isTitle) {
                    return (
                      <h2 className="my-4" key={order}>
                        {question}
                      </h2>
                    );
                  } else if (isBlurb) {
                    return (
                      <div key={order}>
                        <RichTextContent node={answer} />
                      </div>
                    );
                  } else {
                    return (
                      <div key={order} className="accordion-item">
                        <h2 className="accordion-header" id={`heading${order}`}>
                          <button
                            className="accordion-button collapsed"
                            type="button"
                            data-bs-toggle="collapse"
                            data-bs-target={`#collapse${order}`}
                            aria-expanded="false"
                            aria-controls={`collapse${order}`}
                          >
                            {question}
                          </button>
                        </h2>
                        <div
                          id={`collapse${order}`}
                          className="accordion-collapse collapse"
                          aria-labelledby={`heading${order}`}
                          data-bs-parent="#faq"
                        >
                          <div className="accordion-body">
                            <RichTextContent node={answer} />
                          </div>
                        </div>
                      </div>
                    );
                  }
                })}
              </div>
            </div>
          </div>
        </div>
      </section>
      <Footer />
    </m.main>
  );
}
